import type { Type } from '@angular/core';
import { ContentChild, Directive, inject } from '@angular/core';

import { SelectedItemCounterComponent } from './selected-item-counter.component';
import { SelectedItemCounterDirective } from './selected-item-counter.directive';
import { TemplateResolver } from '../../../utils/template-resolver';

@Directive({
  standalone: true,
  selector: 'rt-select2-selected-item-counter-resolver',
})
export class SelectedItemCounterResolverDirective extends TemplateResolver<
  SelectedItemCounterDirective<any>,
  { optional: false }
> {
  @ContentChild(SelectedItemCounterDirective)
  public override contentDirective?: SelectedItemCounterDirective<any>;
  public override injectedComponent = <Type<SelectedItemCounterComponent>>(
    (<unknown>inject(SelectedItemCounterComponent, { optional: true }))
  );
  public override defaultComponent = SelectedItemCounterComponent;
}
